import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Guarded one-time recovery for stale dynamic-import or ChunkLoadError failures
if (typeof window !== 'undefined') {
  const handleChunkError = (error: any) => {
    const errorMessage = String(error?.message || error || '').toLowerCase();
    const isChunkError = 
      errorMessage.includes('failed to load module script') ||
      errorMessage.includes('loading chunk') ||
      errorMessage.includes('chunkloaderror') ||
      errorMessage.includes('dynamic import');
      
    if (isChunkError) {
      const hasReloaded = sessionStorage.getItem('chunk-load-error-reload');
      if (!hasReloaded) {
        sessionStorage.setItem('chunk-load-error-reload', 'true');
        console.warn('Chunk load error detected, performing a guarded one-time page reload...');
        window.location.reload();
      } else {
        console.error('Chunk load error persisted after a guarded reload. Preventing infinite reload loop.');
      }
    }
  };

  window.addEventListener('error', (event) => {
    const target = event.target as any;
    const isScriptOrLink = target && (target.tagName === 'SCRIPT' || target.tagName === 'LINK');
    const srcUrl = target?.src || target?.href || '';
    const isAssetUrl = srcUrl.includes('/assets/');
    
    if (isScriptOrLink && isAssetUrl) {
      const hasReloaded = sessionStorage.getItem('chunk-load-error-reload');
      if (!hasReloaded) {
        sessionStorage.setItem('chunk-load-error-reload', 'true');
        console.warn('Asset resource script/link load error detected, performing a guarded one-time page reload...', srcUrl);
        window.location.reload();
      } else {
        console.error('Asset resource load error persisted after reload for:', srcUrl);
      }
      return;
    }
    
    handleChunkError(event.error || event);
  }, true); // Use capture phase to catch resource loading errors

  window.addEventListener('unhandledrejection', (event) => {
    handleChunkError(event.reason);
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
